import { ConnectedGroupsTable } from 'features/group/table';

export function ChargePointsGroupsListPage() {
  return <ConnectedGroupsTable type={2} />;
}
